export const DATATOASTTYPETYPEPOPUP = 'DATA_TOAST_TYPE_POPUP';

export interface DataToastTypePopUp {
  type: typeof DATATOASTTYPETYPEPOPUP;
  data: any;
}